import React, {useState} from 'react';
import {ListItem, ListItemSecondaryAction, ListItemText, Switch} from '@mui/material';

const EarlyFeature = ({feature}) => {
  const [isActive, setIsActive] = useState(() => {
    return feature.consent === 'enabled';
  });

  const handleChange = (event, value) => {
    feature.updateConsent(value ? 'enabled' : 'disabled');
    setIsActive(value);
  };

  return (
    <ListItem>
      <ListItemText id={feature.slug} primary={feature.name} />
      <ListItemSecondaryAction>
        <Switch edge='end' onChange={handleChange} checked={isActive} inputProps={{'aria-labelledby': feature.slug}} />
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export {EarlyFeature};
